import type { IconData } from '@stacksjs/iconify-core'

export const uiDesignWebsite: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 7.625H1.53v-4.57H0v25.9h1.53V9.145h28.95v19.81H32v-25.9h-1.52zM1.53 28.955h28.95v1.52H1.53Z\"/><path fill=\"currentColor\" d=\"M25.91 19.815h1.52v4.57h-1.52Zm-1.53 4.57h1.53v1.52h-1.53Zm0-6.1h1.53v1.53h-1.53Zm-4.57 7.62h4.57v1.53h-4.57Zm4.57-7.62v-1.52h-1.52v-6.09H4.57v9.14h3.05v-1.53H6.1v-6.09h15.24v4.57h-1.53v1.52zm-6.09 6.1h1.52v1.52h-1.52Z\"/><path fill=\"currentColor\" d=\"M18.29 18.285h1.52v1.53h-1.52Zm-1.53 1.53h1.53v4.57h-1.53ZM9.14 4.575h1.53v1.52H9.14ZM6.1 21.335v1.53H4.57v1.52h10.67v-4.57h-1.52v-1.53h-1.53v-1.52h-1.52v1.52H9.14v1.53H7.62v1.52zm0-16.76h1.52v1.52H6.1Zm-3.05 0h1.52v1.52H3.05Zm-1.52-3.05h28.95v1.53H1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default uiDesignWebsite
